export default {
	es: {

		enlaces: {
			actualidad: '/actualidad',
			sala_de_prensa: "/sala-de-prensa",
			contacto: "/contacto",
			trabaja_con_nosotros: "/trabaja-con-nosotros",
			politica_privacidad: "/politica-de-privacidad",
			politica_cookies: "/politica-de-cookies",
		},
		formulario: {
			nombre: "Nombre",
			nombre_apellidos: "Nombre y apellidos",
			apellidos: "Apellidos",
			email: "Email",
			mensaje: "Mensaje",
			fecha_nacimiento: "Fecha de nacimiento",
			dia: "Día",
			mes: "Mes",
			anyo: "Año",
			area_interes: "Área de su interés",
			trabaja_actualmente: "¿Trabaja actualmente?",
			si: "Si",
			no: "No",
			carta_presentacion: "Carta de presentacion",
			meses: {
				Enero: "Enero",
				Febrero: "Febrero",
				Marzo: "Marzo",
				Abril: "Abril",
				Mayo: "Mayo",
				Junio: "Junio",
				Julio: "Julio",
				Agosto: "Agosto",
				Septiembre: "Septiembre",
				Octubre: "Octubre",
				Noviembre: "Noviembre",
				Diciembre: "Diciembre"
			},
			archivo_adjunto: "Adjuntar archivo",
			adjuntar_cv: "Adjuntar CV",
			introduce_mail: "Introduce tu email",
			pais: "País",
			telefono: "Teléfono",
			he_leido: "He leído y acepto la",
			y_acepto: "política de privacidad",
			enviar: "Enviar",
			enviado: "Enviado",
		},
		faqs: [
			{
				title: "¿CÓMO EMPEZAMOS?",
				description: "Primero <strong>agendamos una valoración inicial</strong> gratuita (60 min). <strong>Evaluamos tu capacidad de movimiento, historial y objetivos</strong>. Vemos si encajamos. Si tiene sentido trabajar juntos, <strong>diseñamos tu plan</strong> y te explico cómo funciona.",
			},
			{
				title: "¿QUÉ INCLUYE CADA SESIÓN? ",
				description: "- <strong>Calentamiento específico</strong> (movilidad y activación)<br>- <strong>Trabajo de fuerza</strong> con patrones fundamentales<br>- <strong>Core</strong> y estabilidad<br>- <strong>Acondicionamiento cardiovascular</strong> adaptado<br>- <strong>Seguimiento</strong> y ajustes según tu progreso",
			},
			{
				title: "¿CUÁNTO DURA CADA SESIÓN?",
				description: "<strong>60 minutos</strong>. Tiempo suficiente para trabajar con calidad y eficiencia sin que interfiera con tu día.",
			},
			{
				title: "¿CUÁNTAS SESIONES A LA SEMANA NECESITO?",
				description: "Trabajo con un <strong>máximo de 2 sesiones presenciales por semana</strong> por persona. Agenda limitada, calidad sobre cantidad. <br>Si quieres entrenar más días, ofrezco <strong>opción híbrida presencial + online</strong>: que diseño y superviso personalmente.",
			},

			{
				title: "¿PUEDO ENTRENAR EN PAREJA? ",
				description: "<strong>Sí</strong>. Sesiones en pareja disponibles con <strong>tarifa especial</strong>.<br>Ambos deben estar en un <strong>nivel similar</strong> para aprovechar bien la sesión. <strong>Mínimo 3 meses de compromiso</strong>. En la valoración inicial te explico cómo funciona.",
			},
			{
				title: "¿OFRECEÍS ENTRENAMIENTO ONLINE? ",
				description: "Sí. <strong>Entrenamiento online completamente individualizado</strong> para ejecutivos +40 que no pueden venir al estudio.<br><strong>Planificación personalizada, seguimiento semanal, videollamadas cada 6 semanas</strong>. No es un programa genérico descargable.<br><u><a href='https://entrenamientoonline.myworkoutstudio.com' target='_blank'>Más información sobre entrenamiento online</a></u>"
			},
			{
				title: "¿NECESITO EXPERIENCIA PREVIA? ",
				description: "<strong>No. Adaptamos cada programa a tu nivel actual.</strong><br><strong>Lo importante no es dónde empiezas, sino que estés dispuesto a comprometerte con el proceso.</strong>"
			},
			{
				title: "¿QUÉ PASA SI TENGO LESIONES O LIMITACIONES? ",
				description: "Eso es precisamente lo que evaluamos en la valoración inicial.<br><strong>Diseñamos tu plan considerando tu historial completo</strong>: lesiones previas, limitaciones actuales, dolores recurrentes. Entrenamos respetando tu cuerpo, no contra él.",
			},
			{
				title: "¿QUÉ PASA SI MI AGENDA ES MUY VARIABLE? ",
				description: "Tienes opciones:<br>1. <strong>Bonos sin caducidad</strong>: entrenas cuando estás disponible, sin presión de fechas.<br>2. <strong>Entrenamiento online</strong>: mantienes constancia desde donde estés.<br>3. <strong>Híbrido</strong>: presencial cuando estás en Madrid + online cuando viajas.<br>Hablamos y encontramos la mejor forma de adaptarnos a tu realidad."
			},
			{
				title: "¿ACEPTAS A TODO EL MUNDO?",
				description: "No. Solo trabajo con <strong>personas que están realmente comprometidas con el proceso</strong>.<br>Si buscas resultados rápidos o soluciones mágicas, este no es tu sitio. Si estás dispuesto a invertir tiempo y esfuerzo en construirte durante años, hablemos."
			},
			{
				title: "¿CUÁNTO CUESTA EL ENTRENAMIENTO? ",
				description: "<strong>Mi tarifa refleja +10 años de experiencia</strong>, certificaciones internacionales (StrongFirst Team Leader, NSCA-CSCS) y un enfoque ultra-individualizado.<br> No es el entrenamiento más barato de Madrid. Es el que funciona a largo plazo.<br><strong>En la valoración inicial hablamos de tu situación y te explico estructura y tarifas</strong>. Sin compromiso. <u><a href='/#contact' target='_blank'>Agenda tu valoración aquí</a></u> "
			},
			{
				title: "¿CÓMO FUNCIONAN LOS BONOS DE SESIONES? ",
				description: '<strong>Los bonos no caducan. Pagas por adelantado un paquete de sesiones y las usas según tu agenda</strong>, sin presión de fechas límite.<br> Esto te da flexibilidad real para semanas intensas de trabajo, viajes o imprevistos.'
			},
			{
				title: "¿CUÁL ES LA POLÍTICA DE CANCELACIÓN? ",
				description: '<strong>Cancelaciones con mínimo 24h de antelación sin cargo.<br>Cancelaciones con menos de 24h: se cobra la sesión completa.</strong><br>Entiendo imprevistos, pero mi agenda es limitada y ese tiempo podría haber sido de otro cliente.'
			},
			{
				title: "¿DÓNDE ESTÁ EL ESTUDIO? ",
				description: "C/ Larra 19, 28004 – Madrid <br>En <strong>pleno centro</strong>, bien conectado por metro y autobús. "
			},
			{
				title: "¿CUÁL ES EL HORARIO?",
				description: "<strong>Lunes a Viernes</strong>: 7:30h a 15:00h<br><strong>Tardes</strong>: De forma puntual (consultar disponibilidad)<br><strong>Sábado y Domingo</strong>: Cerrado "
			},
			{
				title: "¿PUEDO HACER UNA VALORACIÓN INICIAL ANTES DE COMPROMETERME? ",
				description: '<strong>Sí. La valoración inicial (30 min) es sin compromiso.<br>Evaluamos tu capacidad de movimiento, historial y objetivos.</strong> Vemos si encajamos. Si tiene sentido trabajar juntos, te explico cómo funciona y diseñamos tu plan. Si no encajamos, sin problema. No hay presión.'
			}
			

		],

	},
	en: {
		enlaces: {
			actualidad: '/news',
			sala_de_prensa: "/press-room",
			contacto: "/contact",
			trabaja_con_nosotros: "/work-with-us",
			politica_privacidad: "/privacy-policy",
			politica_cookies: "/cookies-policy",
		}
	}
}



// WEBPACK FOOTER //
// ./src/translations/index.js